import React from "react";
import { Box } from "@mui/material";

const Cards9 = () => {
  const layout = [
    { num: 1, col: 1, row: 1 },
    { num: 2, col: 2, row: 1 },
    { num: 3, col: 3, row: 1 },
    { num: 4, col: 1, row: 2 },
    { num: 5, col: 2, row: 2 },
    { num: 6, col: 3, row: 2 },
    { num: 7, col: 1, row: 3 },
    { num: 8, col: 2, row: 3 },
    { num: 9, col: 3, row: 3 },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        paddingTop: 2,
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 50px)",
          gridTemplateRows: "repeat(3, 50px)",
          gap: "10px",
        }}
      >
        {layout.map(({ num, col, row }) => (
          <Box
            key={num}
            sx={{
              width: 43,
              height: 54,
              backgroundColor: "#1976d2",
              borderRadius: "10px",
              color: "white",
              fontWeight: "bold",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              userSelect: "none",
              gridColumn: col,
              gridRow: row,
            }}
          >
            {num}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Cards9;
